import { cn } from '@loop3/ui'
import { useLupeThread } from '@/hooks/useLupeThread'

/** Dot on the Lupe nav item: pulsing while Lupe answers off-page, steady once that answer is unseen. */
export function LupeNavSignal() {
  const { answeringElsewhere: answering, unseen } = useLupeThread()
  if (!answering && !unseen) return null

  return (
    <span className="ml-auto flex items-center">
      <span
        aria-hidden
        className={cn(
          'size-1.5 rounded-full bg-[var(--l3-violet)]',
          answering && 'bui-motion animate-pulse'
        )}
      />
      <span className="sr-only">
        {answering ? 'Lupe is answering' : 'New answer from Lupe'}
      </span>
    </span>
  )
}
